import {useState, useRef} from 'react'

type FormState<T> = {
  state: T
  update: <P extends keyof T>(property: P, value: T[P]) => void
  clear: () => void
}

export function useForm<T>(formData: T): FormState<T> {
  const defaultFormData = useRef(formData)
  const [state, setState] = useState(formData)

  return {
    state,
    update: (property, value) => setState({...state, [property]: value}),
    clear: () => setState({...defaultFormData.current}),
  }
}
